const floorStatics = {
  p0_m: {
    sectionPath: '/floor_0m',
    locationKey: 'p0_m',
    sectionKey: 'WOMAN',
    floorKey: '0m',
    section: 'p0_m.section.name',
    floor: 'p0_m.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_M.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_M.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0m',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_m.path.floorMap.linkName',
        title: 'p0_m.path.floorMap.title',
        info: 'p0_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_M.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_M.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.floorMap.description.title',
          content: 'p0_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_m.path.pickUpSize.linkName',
        title: 'p0_m.path.pickUpSize.title',
        info: 'p0_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_M_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_M_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.pickUpSize.description.title',
          content: 'p0_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p1_m: {
    sectionPath: '/floor_1m',
    locationKey: 'p1_m',
    sectionKey: 'WOMAN',
    floorKey: '1m',
    section: 'p1_m.section.name',
    floor: 'p1_m.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_M.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_M.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1m',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_m.path.floorMap.linkName',
        title: 'p1_m.path.floorMap.title',
        info: 'p1_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_M.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_M.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_m.path.floorMap.description.title',
          content: 'p1_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1m',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_m.path.pickUpSize.linkName',
        title: 'p1_m.path.pickUpSize.title',
        info: 'p1_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_M_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_M_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_m.path.pickUpSize.description.title',
          content: 'p1_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p2_m: {
    sectionPath: '/floor_2m',
    locationKey: 'p2_m',
    sectionKey: 'WOMAN',
    floorKey: '2m',
    section: 'p2_m.section.name',
    floor: 'p2_m.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2m',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_m.path.floorMap.linkName',
        title: 'p2_m.path.floorMap.title',
        info: 'p2_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_m.path.floorMap.description.title',
          content: 'p2_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2m',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p2_m.path.pickUpSize.linkName',
        title: 'p2_m.path.pickUpSize.title',
        info: 'p2_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_m.path.pickUpSize.description.title',
          content: 'p2_m.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_2m',
        path: '/athleticz',
        exact: true,
        location: 'athleticz',
        linkName: 'p2_m.path.athleticz.linkName',
        title: 'p2_m.path.athleticz.title',
        info: 'p2_m.path.athleticz.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M_Athleticz_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_M_Athleticz.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_m.path.athleticz.description.title',
          content: 'p2_m.path.athleticz.description.content',
        },
      },
    ],
  },
  p0_w: {
    sectionPath: '/floor_0w',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0w',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0w',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_w.path.pickUpSize.linkName',
        title: 'p0_w.path.pickUpSize.title',
        info: 'p0_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.pickUpSize.description.title',
          content: 'p0_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p0_w.path.fittingRooms.linkName',
        title: 'p0_w.path.fittingRooms.title',
        info: 'p0_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P0_W_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.fittingRooms.description.title',
          content: 'p0_w.path.fittingRooms.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1w',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN',
    floorKey: '1w',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1w',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1w',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_w.path.pickUpSize.linkName',
        title: 'p1_w.path.pickUpSize.title',
        info: 'p1_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.pickUpSize.description.title',
          content: 'p1_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_1w',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p1_w.path.fittingRooms.linkName',
        title: 'p1_w.path.fittingRooms.title',
        info: 'p1_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.fittingRooms.description.title',
          content: 'p1_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_1w',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p1_w.path.beauty.linkName',
        title: 'p1_w.path.beauty.title',
        info: 'p1_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W_Beauty_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P1_W_Beauty.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.beauty.description.title',
          content: 'p1_w.path.beauty.description.content',
        },
      },
    ],
  },
  p2_w: {
    sectionPath: '/floor_2w',
    locationKey: 'p2_w',
    sectionKey: 'WOMAN',
    floorKey: '2w',
    section: 'p2_w.section.name',
    floor: 'p2_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2w',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_w.path.floorMap.linkName',
        title: 'p2_w.path.floorMap.title',
        info: 'p2_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.floorMap.description.title',
          content: 'p2_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2w',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p2_w.path.pickUpSize.linkName',
        title: 'p2_w.path.pickUpSize.title',
        info: 'p2_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W_EncuentraTalla.jpg?ts=163120150000',
        description: {
          type: 'default',
          title: 'p2_w.path.pickUpSize.description.title',
          content: 'p2_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_2w',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p2_w.path.fittingRooms.linkName',
        title: 'p2_w.path.fittingRooms.title',
        info: 'p2_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.fittingRooms.description.title',
          content: 'p2_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_2w',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p2_w.path.onlinePickup.linkName',
        title: 'p2_w.path.onlinePickup.title',
        info: 'p2_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_P2_W_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.onlinePickup.description.title',
          content: 'p2_w.path.onlinePickup.description.content',
        },
      },
    ],
  },
  s1_k: {
    sectionPath: '/floor_-1',
    locationKey: 's1_k',
    sectionKey: 'WOMAN',
    floorKey: '-1',
    section: 's1_k.section.name',
    floor: 's1_k.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_S1_K.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3197_S1_K.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2w',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 's1_k.path.floorMap.linkName',
        title: 's1_k.path.floorMap.title',
        info: 's1_k.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_S1_K.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_S1_K.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_k.path.floorMap.description.title',
          content: 's1_k.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2w',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 's1_k.path.pickUpSize.linkName',
        title: 's1_k.path.pickUpSize.title',
        info: 's1_k.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_S1_K_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3197_S1_K_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_k.path.pickUpSize.description.title',
          content: 's1_k.path.pickUpSize.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'it-IT',
    name: 'Italiano',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/3197_MIL_VITTORIO_EMANUELE_II_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
